import Fetch from '@/hooks/fetch';
import { pagingHookConfig } from '@/hooks/paging';
import actions from '../constants';

export default {
  useFetchNotifications: ({ category, code, event }, readStatus, config = pagingHookConfig()) => Fetch.useFetchDispatch(
    actions.FETCH_NOTIFICATIONS,
    readStatus,
    { category, code, event },
    config,
  ),
};
